define.alias("ember-composable-helpers/helpers/toggle", "settings/helpers/toggle");